const colors = {
	palette_1: '#FFFFFF',
	palette_2: '#FECAC9',
	palette_3: '#E2DFDF',
	palette_4: '#F9F9F9',
	palette_5: '#FFE9E9',
	palette_6: '#000000',
	palette_7: '#F96B60',
	palette_8: '#4B43E2',
	palette_9: '#F92E32',
	palette_10: '#CDF6D9',
	splash_image: '#006A5C',
	inactive_1: '#838383',
} as const

export { colors }
module.exports = { colors }
